import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { FilesService } from 'src/app/modules/common/_services/files.service';
import { File } from 'src/app/modules/common/_types/file';
import { CaseFile } from '../../_types/case-file';
import { CasesFilesService } from '../../_services/cases-files.service';
import { CaseService } from '../../_types/case-service';
import { CasesServicesService } from '../../_services/cases-services.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { CaseFileCategory } from '../../_types/case-file-category';
import { CasesFilesCategoriesService } from '../../_services/cases-files-categories.service';
import { CaseNoteFile } from '../../_types/case-note-file';
import { CasesNotesFilesService } from '../../_services/cases-notes-files.service';

@Component({
    selector: 'app-file',
    templateUrl: './file-note.component.html',
    styleUrls: ['./file-note.component.scss'],
    standalone: false
})
export class CasesNotesFileComponent {
  public caseFileFormGroup!: RxFormGroup;
  public caseNoteFile: CaseNoteFile = new CaseNoteFile();
  public files: any[] = [];

  constructor(
    private filesService: FilesService,
    private casesNotesFilesService: CasesNotesFilesService,
    private casesServicesService: CasesServicesService,
    private casesFilesCategoriesService: CasesFilesCategoriesService,
    private config: DynamicDialogConfig,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    this.caseFileFormGroup = this.formBuilder.formGroup(CaseNoteFile) as RxFormGroup;
  }

  async ngOnInit() {
    let caseNoteFileId = this.config.data.caseNoteFileId;
    if (caseNoteFileId) {
      await this.loadCaseNoteFile(caseNoteFileId);
    } else {
      this.caseNoteFile.caseNoteId = this.config.data.CaseNoteId;
      this.caseFileFormGroup.patchValue(this.caseNoteFile);
    }
  }

  async loadCaseNoteFile(caseNoteFileId: string) {
    this.caseNoteFile = await firstValueFrom(this.casesNotesFilesService.get(caseNoteFileId));
    this.caseFileFormGroup.patchValue(this.caseNoteFile);
  }

  async onFileSelect(event: any) {
    let files = event.files;
    for (let file of files) {
      this.files.push(file);
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.caseFileFormGroup);
    if (valid && (this.files.length > 0 || this.caseNoteFile.fileId)) {
      this.caseNoteFile = Object.assign(this.caseNoteFile, this.caseFileFormGroup.value);
      if (this.files.length > 0) {
        try {
          for (let file of this.files) {
            let data: File = new File();
            data.fileName = file.name;
            data.size = file.size;
            data.contentType = file.type;
            //data.path = file.name;

            //creamos el file
            let fileResponse = await firstValueFrom(this.filesService.save(data));

            //subimos el fichero al file
            let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, file));

            //guardamos el file en el expediente
            this.caseNoteFile.fileId = fileResponse.id as string;
            await firstValueFrom(this.casesNotesFilesService.save(this.caseNoteFile));
          }
        } catch (error) {
          this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al guardar los ficheros." });
        }
      } else {
        //guardamos el file en el expediente
        await firstValueFrom(this.casesNotesFilesService.save(this.caseNoteFile));
      }

      //this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Ficheros guardados correctamente." });
      this.dynamicDialogRef.close(this.files);

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

}
